import { realBricksApi } from '../../utils/axiosInterceptors';

/**
 *
 * @typedef {object} ReqBody
 * @property {string} referralCode
 * @param {ReqBody} reqBody
 */
export const saveReferralCodeApi = async (reqBody) => {
  const response = await realBricksApi.put('/api/v1/user/referral-code', reqBody);
  return response.data;
};

export const verifyReferralCodeApi = async(reqBody) => {
  const response = await realBricksApi.put('/api/v1/user/verify-referral-code',reqBody);
  return response.data;
}
